import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UserRoleAddModelComponent } from '../user-role-add-model/user-role-add-model.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../core/api.service';
import { UtilityService } from '../../../core/global/utility.service';
import { Editor, Toolbar } from 'ngx-editor';
import { UploadCsvModalComponent } from "../../upload-csv-modal/upload-csv-modal.component";
import { CONFIG } from 'src/app/core/config';
@Component({
  selector: 'app-user-role-details',
  templateUrl: './user-role-details.component.html',
  styleUrls: ['./user-role-details.component.sass']
})
export class UserRoleDetailsComponent {
  userList = [];
  deleteID = '';
  modalConfirmation;
  searchInput: any = '';
  sortedtby: any = 'id';
  page: number = 1; // Enter 1 if you want to use the server side pagination 
  p;
  limit = 10
  count
  password
  pass
  userType: string;
  totalPages = [];
  last: any;
  paramsData: any
  constructor(private router: Router, private modalService: NgbModal, private _adminService: ApiService, private _utility: UtilityService, private route: ActivatedRoute,) { }
  ngOnInit(): void {
    this.userType = localStorage.getItem('m_ind_type');
    this.route.queryParams.subscribe(params => {
      this.paramsData = params
    });
    this.getUserRole();
  }
  getUserRole() {
    let url = "qr/user_role_list";
    let whereData = []
    if (this.paramsData.event) {
      whereData.push({ 'field': '`qr_user_role`.`org_ref_id`', 'value': this.paramsData.event, 'type': 'WHERE', 'nested': '' })
    }
    if (this.paramsData.gate && (!this.paramsData.day && !this.paramsData.dining)) {
      whereData.push({ 'field': '`qr_user_role`.`breakfast_gate`', 'value': this.paramsData.gate, 'type': 'AND', 'query_type': 'FIND_IN_SET', 'nested': '(' }, { 'field': '`qr_user_role`.`lunch_gate`', 'value': this.paramsData.gate, 'type': 'OR', 'query_type': 'FIND_IN_SET', 'nested': '' }, { 'field': '`qr_user_role`.`tea_gate`', 'value': this.paramsData.gate, 'type': 'OR', 'query_type': 'FIND_IN_SET', 'nested': '' }, { 'field': '`qr_user_role`.`dinner_gate`', 'value': this.paramsData.gate, 'type': 'OR', 'query_type': 'FIND_IN_SET', 'nested': ')' })
    }
    if (this.paramsData.day && this.paramsData.dining) {
      whereData.push({ 'field': '`qr_user_role`.`day`', 'value': this.paramsData.day, 'type': 'AND', 'nested': '(' },
        {
          'field': `qr_user_role.${(this.paramsData.dining == 1 ? 'breakfast_gate' : this.paramsData.dining == 2 ? 'lunch_gate' : this.paramsData.dining == 3 ? 'tea_gate' : this.paramsData.dining == 4 ? 'dinner_gate' : '')}`,
          'value': this.paramsData.gate, 'type': 'AND', 'query_type': 'FIND_IN_SET', 'nested': ''
        },
        { 'field':  `qr_user_role.${(this.paramsData.dining == 1 ? 'breakfast_valid' : this.paramsData.dining == 2 ? 'lunch_valid' : this.paramsData.dining == 3 ? 'tea_valid' : this.paramsData.dining == 4 ? 'dinner_valid' : '')}`, 'value': 1, 'type': 'AND', 'nested': ')' })
    }
    let data = { searchText: this.searchInput, sortby: this.sortedtby, page: this.page, whereData: whereData };
    this._utility.showLoader();
    this._adminService.post(url, data).subscribe((response) => {
      this._utility.hideLoader();
      if (response.status == 200) {
        this.userList = response.data;
        this.count = response.total;
        this.limit = response.limit;
        for (var j = 0; j < response.pages; j++) {
          this.totalPages[j] = j + 1;
        }
        this.last = response.pages;
      } else {
        this._utility.toastError(response.message);
      }
    })
  }
  paginate(page) {
    this.page = page;
    this.getUserRole();
  }
  importData(Id) {
    const modalRef = this.modalService.open(UploadCsvModalComponent, { centered: true, backdrop: "static", size: 'm' }); // xl, lg , sm
    modalRef.componentInstance.endPoint = 'users/qr-assign-upload'
    modalRef.result.then((result) => {
      this.getUserRole();
    }, (reason) => {

    });
  }
  orgModal(Id) {
    window.localStorage.setItem('pushUserId', Id);
    const modalRef = this.modalService.open(UserRoleAddModelComponent, { centered: true, backdrop: "static", size: 'xl' }); // xl, lg , sm
    modalRef.result.then((result) => {
      this.getUserRole();
    }, (reason) => {
      //
    });
  }
  confirmModal(content, id) {
    this.deleteID = id;
    this.modalConfirmation = this.modalService.open(content, { centered: true });
    this.modalConfirmation.result.then((result) => {
      //this.getUserRole('');
    }, (reason) => {
      //
    });
  }
  saveDataPush(id) {

    this.router.navigateByUrl('/role-details/' + id);
  }
  closeconfirm(param, id) {
    if (param == 'yes') {
      let url = 'qr/user_role_remove';
      let data = { 'id': this.deleteID }
      this._adminService.delete(url, data).subscribe((response) => {
        //this.spinnerService.hide();
        if (response.success == true) {
          this.getUserRole();
          this._utility.toastSuccess(response.message);
        } else {
          this._utility.toastError(response.message);
        }
        this.modalConfirmation.close();
      })

    } else {
      this.modalConfirmation.close();
    }

  }
  searchChanged() {
    this.page = 1;
    this.getUserRole();

  }
  exportData() {
    this._utility.showLoader()
    let url = 'qr/assign_export'
    this._adminService.get(url).subscribe((response) => {
      this._utility.hideLoader()
      if (response.status == 200) {
        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', CONFIG.API_ENDPOINT + 'public/user/assign_role.csv');
        link.setAttribute('download', `Assign Roles.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();

      } else {
        this._utility.toastError(response.message);
      }
    })
  }
}
